import { semanticColors } from "./colors";
import { typography } from "./typography";

// Page scaffolding shared by the payments screens: the heading, the row it sits
// in, and the centred action rows. These repeat verbatim across the
// configuration list, form, next steps, detail, documents and payment request,
// so they live here rather than being retyped in each one.
//
// Field and form-control styling belongs in `fieldStyles.ts` instead.

/** The centred page heading. */
export const pageTitleSx = {
  ...typography.heading.xl,
  color: semanticColors.text.primary,
  textAlign: "center"
};

/**
 * The row carrying the page heading and whatever sits beside it — the help
 * button, sometimes a refresh action.
 */
export const pageHeaderRowSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

/** A centred row of buttons, typically at the foot of a screen. */
export const centeredActionsSx = {
  display: "flex",
  justifyContent: "center"
};

/** The vertical stack a payments screen lays its sections out in. */
export const pageColumnSx = {
  display: "flex",
  flexDirection: "column",
  gap: 3
};
